






























































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl
} from "@root/lib/decorator";
const storeSpace = namespace("warrantyCheck");
@Component({})
@SearchbarControl()
@pagination("getDataList", { pageSize: 50 })
@loading(true)
export default class WarrantyCheck extends Vue {
  @storeSpace.Action queryWarrantyFeedback;
  @storeSpace.Action("exportWarrantyFeedback") export;
  @storeSpace.Getter("filterDatas") dataList;

  formOptionList: any = [
    {
      label: "申请时间",
      key: "time",
      type: "datePicker",
      value: "",
      pickerType: "datetimerange",
      rangeSeparator: "-",
      prefixIcon: "",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      defaultTime: ["00:00:00", "23:59:59"]
    },

    {
      key: "feedbackStatus",
      value: null,
      label: "审核状态",
      type: "ddPicker",
      ddCode: "FEEDBACK_STATUS",
      stateName: "FEEDBACK_STATUS"
    },
    {
      key: "warrantyCard",
      value: "",
      label: "质保卡号",
      type: "input"
    },
    {
      key: "ownerMobile",
      value: "",
      label: "车主手机号",
      type: "input"
    },
    {
      key: "orgCode",
      value: "",
      label: "理赔门店",
      type: "input"
    }
  ];
  form: any = {
    time: null,
    orgCode: "",
    ownerMobile: "",
    warrantyCard: "",
    feedbackStatus: null
  };
  loading: boolean = false;
  total: number = 0;

  get searchParams() {
    const { time, ...other } = this.form;
    return {
      startTime: (time && time[0]) || null,
      endTime: (time && time[1]) || null,
      ...other
    };
  }
  mounted() {
    this.getDataList();
  }
  @loadingCatch
  async getDataList() {
    const { pageSize, currentPage: pageNum }: any = this;
    const { searchParams: input } = this;
    try {
      const { total = 0 } = await this.queryWarrantyFeedback({
        pageInput: {
          pageSize,
          pageNum
        },
        input
      });
      this.total = total;
    } catch (error) {
      console.log(error);
    }
  }
  async handleExport() {
    (this.$refs.gtExportDialog as any).visible = true;
  }
  async exportExcelFn() {
    const { searchParams: input } = this;
    await this.export({
      input
    });
  }

  onFormDataChange(val: any) {
    this.form = { ...val };
  }
}
